// import { register } from "../../module/Register/locale/register.en.js";
import { home } from "@/module/Home/locale/home.en.js";
import { profile } from "@/module/Profile/locale/profile.en.js";
import Register from "@/module/Register/locale/Register.en";
import Promotion from "@/module/Promotion/locale/Promotion.en";
import platinumServiceEn from "@/module/PlatinumService/locale/platinumService.en";
import historyPage from "@/module/History/locale/history.en";
import cardPrivilegesEn from "@/module/CardPrivileges/locale/cardPrivileges.en";
import UltimateService from "@/module/UltimateService/locale/UtimateService.en";
import welcome from "@/module/Welcome/locale/welcome.en";
import privacyMenu from "../../module/PrivacyMenu/locale/privacymenu.en";

export const en = {
    default: {
        search: 'SEARCH',
        confirm: 'CONFIRM',
        ok: 'OK',
        cancel: 'CANCEL',
        close: 'CLOSE',
        accept: 'Accept',
        save: 'Save',
        error: 'Error !',
        date: 'Date',
        edit: 'Edit',
        period: 'Period',
        soldOut: 'Fully redeemed'
    },
    bottomSheet: {
        sorry: 'Sorry'
    },

    home: home,
    profile: profile,
    register: Register,
    promotion: Promotion,
    platinumService: platinumServiceEn,
    historyPage: historyPage,
    cardPrivileges: cardPrivilegesEn,
    ultimateService: UltimateService,
    welcome,
    privacymenu: privacyMenu,

    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        hours: 'hour',
        hours_short: 'hr',
        seconds: 'second',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }]
    },
    redeem_button: {
        default: 'Redeem',
        none: '',
        soldOut: 'Sorry, this reward has been fully redeemed.',
        soldOutBuy: 'Sorry, this reward has been fully redeemed.',
        maxPerPerson: 'You have reached the redeeming limit.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This privilege requires user action before redemption, please review the conditions first.',
        campaignPeriodInvalid: 'Sorry,  You are not able to redeem at this moment. please check the date/time and try again.',
        campaignExpired: 'This privilege has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.'
    },
    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'Confirm',
        default: 'Confirm?',
        defualt_have_time: 'The code is valid for {0} after confirmation and cannot be canceled or refunded.',
        default_no_time: 'This redemption cannot be canceled or refunded.',
        delivery: 'Please enter shipping information to redeem',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
        default_after_used: 'This redemption cannot be canceled or refunded.',
        default_after_used_have_time: 'The code is valid for <span class="text-red-1">{0}</span> <br/>after confirmation and cannot be canceled or refunded'
    },
    confirm_used: {
        default: 'Do you want to use this e-voucher now?',
        used_have_time: 'The code will expire in {0} after you click to use now',
        slide_to_used: 'Slide to complete',
        slide_to_used_success: 'Successfully',
        slide_to_used_message: 'Code expires after sliding'
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
    },
    serial: {
        close_btn: 'Close',
        default_privilege_message: 'As design',
        show_code_at_shop: 'Please present code below to <br/> the cashier for redemption',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'Copy Code',

        expire_in: 'Time left : ',
        code_expired: 'This serial has expired.',

        redeem_on: 'Redeem on : {0}',
        view_history: 'View History'
    },
    shipping: {
        headline: 'Shipping address',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'Address name',
            placeholder: 'Address name',
            required: 'Please enter address name',
            too_short: '',
            invalid: '',
        },
        address: {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        isDefaultAddress: 'Is default address.',
        defaultAddress: 'Default',
        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        minutes_after_redeem: 'Valid for use within {0} days after redemption',
    },
    detail: {
        detail: 'Details',
        condition: 'Conditions',
        view_detail: 'View Detail',

        point_unit: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        available_date: 'Date',
        expire_date: 'Expire date : {0}',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
    },
    history: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        date: 'Date : ',

        parcel_number: 'Parcel No. : ',
    },
    faq: {
        fb: 'Message Us On Facebook'
    },
    contact_us: {
        contact_information: 'CONTACT INFORMATION',
        detail: 'We will respond to you within 24 hours.',
        fb: 'JCB Thailand Facebook Fanpage'
    },
    lang: {
        thai: 'ไทย',
        eng: 'ENG',
    },
    sidemenu:{
        service_info: 'My Account',
        special_for_u: 'My Exclusive Deal',
        hot_promo: 'Hot Promotion',
        search_promo: 'Search Promotion',
        platinum_service: 'Platinum Service',
        card_privileges: 'Card Privileges',
        apply_card: 'Apply Card',
        privacy: 'Privacy Setting',
        faq: 'FAQ',
        data_privacy: 'Data Privacy',
        term_cond: 'Terms & Conditions',
        contact_us: 'Contact US',
    },
    consent_cookie: {
        title: "ความยินยอมข้อมูลส่วนบุคคลของคุณ",
        message: "บริษัท บัซซี่บีส์ จำกัด ใช้คุกกี้เพื่อมอบประสบการณ์การใช้</br>งานเว็บไซต์ที่ดีที่สุดให้กับคุณ",
        privacy: "ดูรายละเอียดนโยบายความเป็นส่วนตัว",
        confirm: "ให้ความยินยอมทั้งหมด",
    }
};
